<template>
  <span>
    <h3 class="ma-0 pa-0">Case Information</h3>
    <v-row>
      <v-col cols="12" md="12" lg="12" xl="12">
        <!-- Reason for encounter -->
        
        <!-- <v-select v-model="form.reason" :items="reasonItems" placeholder=" ">
          <template v-slot:label>
            <span class="font-weight-bold primary--text"
              >Reason for encounter</span
            >
          </template>
        </v-select> -->

        <v-textarea
          v-model="form.reason"
          placeholder=" "
          class="primary-label"
        >
          <template v-slot:label>
            <span class="font-weight-bold">Reason for encounter</span>
          </template>
        </v-textarea>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="4" lg="4" xl="4">  
        <v-select
          v-model="form.category"
          :items="categoryItems"
          placeholder=" "
        >
          <template v-slot:label>
            <span class="font-weight-bold primary--text">Case Category</span>
          </template>
        </v-select>
      </v-col>

      <v-col cols="12" md="4" lg="4" xl="4">
        <!-- Sub-category -->
        <!-- case category comment -->
          <v-text-field
            v-if="form.category == 'Others'" 
            v-model="form.caseCategoryComments"
            class="primary-label"
          >
          <template v-slot:label>
            <span class="font-weight-bold">Case Category Comment</span>
          </template>
        </v-text-field>
      </v-col>

      <v-col cols="12" md="4" lg="4" xl="4">
        <!-- Sub-category -->
        <v-select v-if="form.category == 'Pediatric'" v-model="form.sub" :items="subCategoryItems" placeholder=" ">
          <template v-slot:label>
            <span class="font-weight-bold primary--text">Sub-category</span>
          </template>
        </v-select>
      </v-col>
    </v-row>

  </span>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => ({
    reasonItems: ["Cough", "Fever", "High Blood Pressure"],
    categoryItems: [
      "Others",
      "Cardiology",
      "Dental Medicine",
      "Dermatology",
      "Endocrinology",
      "ENT-HNS",
      "Gastroenterology",
      "Gen. Medicine",
      "Gen. Surgery",
      "Hematology",
      "Immunology / Allergology",
      "Infectious Disease",
      "Inquiry",
      "Nephrology",
      "Neurology",
      "OB-Gynecology",
      "Occupational Medicine",
      "Ophthalmology",
      "Orthopaedics",
      "Pediatric",
      "Psychiatry",
      "Pulmonology",
      "Rehab Medicine",
      "Rheumatology",
      "Urology"
    ],

    subCategoryItems: [
      "General Pediatrics",
      "Allergology/Immunology",
      "Cardiology",
      "Dentistry",
      "Dermatology",
      "Development",
      "Endocrinology",
      "Ears, Nose and Throat",
      "Gastroenterology",
      "Hematology",
      "Infectious Disease",
      "Nephrology",
      "Neurology",
      "Ophthalmology",
      "Orthopedics",
      "Pulmonology",
      "Surgery"
    ]
  }),
};
</script>